import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AlterarSenhaModal from './AlterarSenhaModal';
import { buildApiErrorMessage } from '../utils/apiError';
import '../styles/Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [mostrarAlterarSenha, setMostrarAlterarSenha] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(email, senha);
      
      // Obter tipo de usuário do token
      const token = localStorage.getItem('access_token');
      const payload = JSON.parse(atob(token.split('.')[1]));
      
      // Verificar se é primeiro acesso de responsável
      if (payload.role === 'RESPONSAVEL' && payload.primeiro_acesso === true) {
        setMostrarAlterarSenha(true);
      } else if (payload.role === 'RESPONSAVEL') {
        navigate('/responsavel/dashboard');
      } else if (payload.role === 'PROFESSOR') {
        navigate('/professor');
      } else {
        navigate('/inicio');
      }
    } catch (err) {
      const { message: friendlyMessage } = buildApiErrorMessage(
        err,
        'Não foi possível entrar. Tente novamente.',
        { context: 'login' }
      );
      setError(friendlyMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleAlteracaoSenhaSuccess = () => {
    // Após alterar senha com sucesso, redireciona para o portal do responsável
    navigate('/responsavel/dashboard');
  };

  return (
    <div className="auth-container">
      <div className="auth-card login-card">
        <div className="auth-header">
          <h1>Fisicore</h1>
          <p>Gestão de Aulas Extracurriculares</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleLogin} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <div className="password-input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                id="senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="Digite sua senha"
                required
                disabled={loading}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/recuperar-senha" className="link">
            Esqueci a senha
          </Link>
          <span className="separator">|</span>
          <Link to="/cadastro" className="link">
            Novo cadastro
          </Link>
        </div>

        <div className="auth-footer">
          <p>© 2026 Fisicore. Todos os direitos reservados.</p>
        </div>
      </div>

      <AlterarSenhaModal
        visible={mostrarAlterarSenha}
        onClose={() => setMostrarAlterarSenha(false)}
        onSuccess={handleAlteracaoSenhaSuccess}
      />
    </div>
  );
};

export default Login;
